import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import RFQModal from "../components/RFQModal";

import {
  LuShieldCheck,
  LuMessagesSquare,
  LuChartLine,
  LuRefreshCcw,
  LuCheck,
} from "react-icons/lu";

import "../assets/css/AIGovernanceLifecycle.css";

const lifecycleCards = [
  {
    icon: <LuShieldCheck />,
    title: "AI Strategy & Policy Framework",
    items: [
      "Establish governance structures, policies, and accountability models for responsible AI adoption.",
      "Define standards for ethical AI, regulatory compliance, and organizational oversight.",
    ],
  },
  {
    icon: <LuMessagesSquare />,
    title: "Risk & Compliance Management",
    items: [
      "Identify, assess, and mitigate AI-related risks across the model lifecycle.",
      "Ensure compliance with industry regulations, data privacy requirements, and internal controls.",
      "Maintain transparency through documentation, audit trails, and governance reviews.",
    ],
  },
  {
    icon: <LuChartLine />,
    title: "Model Monitoring & Performance",
    items: [
      "Continuously monitor model accuracy, fairness, drift, and operational performance.",
      "Track key governance metrics and detect anomalies before they impact business outcomes.",
      "Provide real-time visibility into AI system health and compliance status.",
    ],
  },
  {
    icon: <LuRefreshCcw />,
    title: "Continuous Improvement & Lifecycle Management",
    items: [
      "Manage model updates, retraining, retirement, and version control through governed processes.",
      "Ensure AI systems remain aligned with business objectives, regulatory changes, and evolving risks.",
    ],
  },
];

const timeline = [
  {
    title: "Govern",
    text: "Define policies, roles, and oversight.",
  },
  {
    title: "Assess",
    text: "Evaluate risks, ethics, and compliance.",
  },
  {
    title: "Deploy",
    text: "Launch AI with approved controls.",
  },
  {
    title: "Monitor",
    text: "Track performance, fairness, and risk.",
  },
  {
    title: "Optimize",
    text: "Improve models through ongoing reviews.",
  },
];
const benefits = [
  "Strengthen trust in AI through transparent governance, accountability, and oversight.",
  "Reduce regulatory and operational risks with proactive compliance monitoring.",
  "Improve AI performance through continuous monitoring, validation, and optimization.",
  "Enable scalable and responsible AI adoption aligned with business and regulatory requirements.",
];

const AIGovernanceLifecycle = () => {
  const [show, setShow] = useState(false);

  return (
    <div id="agl-solutions">
      <Navbar />

      {/* HERO */}

      <section className="agl-hero">
        <div className="container agl-hero-grid">
          <div className="agl-hero-content" data-aos="fade-right">
            <span className="section-tag">AI Governance Lifecycle</span>

           <h1>
  Govern AI with
  <br />
  confidence and control.
</h1>

            <p>
  Build, deploy, and manage AI systems responsibly with a comprehensive
  governance framework that ensures compliance, mitigates risk, promotes
  transparency, and drives sustainable business value throughout the AI
  lifecycle.
</p>

            <button className="ccsnl-btn" onClick={() => setShow(true)}>
              Request a Consultation
            </button>
          </div>

          <div className="agl-hero-image" data-aos="fade-left">
            {/* background image in css */}
          </div>
        </div>
      </section>

      <RFQModal show={show} setShow={setShow} />

      <main className="pt-0">
        {/* FOUR STAGES */}

        <section className="container lifecycle-section">
          <span className="section-tag">FOUR STAGES, ONE GOVERNANCE FRAMEWORK</span>

          <h2>
  Four pillars of
  <br />
  AI governance excellence.
</h2>

        <p className="section-text">
  Every stage of the AI lifecycle requires dedicated governance controls,
  ensuring responsible development, deployment, monitoring, and continuous
  improvement.
</p>

          <div className="lifecycle-grid">
            {lifecycleCards.map((card, index) => (
              <div
                key={index}
                className="lifecycle-card"
                data-aos="fade-up"
                data-aos-delay={index * 150}
              >
                <div className="card-icon">{card.icon}</div>

                <h4>{card.title}</h4>

                <ul>
                  {card.items.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>

        {/* DARK TIMELINE */}

        <section className="lifecycle-dark">
          <div className="container">
            <span className="section-tag dark">THE LIFECYCLE</span>

            <h2>One framework. Five governance milestones.</h2>

            <p>
  Effective AI governance is not a one-time exercise. It is a continuous
  lifecycle that ensures AI systems remain compliant, transparent,
  trustworthy, and aligned with business objectives.
</p>

            <div className="timeline">
              {timeline.map((item, index) => (
                <div
                  className="timeline-item"
                  key={index}
                  data-aos="fade-up"
                  data-aos-delay={index * 120}
                >
                  <h5>{item.title}</h5>

                  <p>{item.text}</p>
                </div>
              ))}
            </div>

            <div className="timeline-btn">
              <button className="ccsnl-btn" onClick={() => setShow(true)}>
                Request a Consultation
              </button>
            </div>
          </div>
        </section>

        {/* WHY OUTCESS */}

        <section className="container why-outcess">
          <div className="why-left">
            <span className="section-tag">WHY CHOOSE OUTCESS?</span>

            <h2>AI governance that delivers measurable business assurance.</h2>

            <p>
  Responsible AI requires more than policies. It demands the right
  governance framework, risk controls, monitoring capabilities, and
  operational expertise. Our team helps organizations implement AI
  governance practices that drive innovation while maintaining trust,
  compliance, and accountability.
</p>
          </div>

          <div className="why-right">
            {benefits.map((benefit, index) => (
              <div
                className="benefit"
                key={index}
                data-aos="fade-left"
                data-aos-delay={index * 120}
              >
                <div className="benefit-icon">
                  <LuCheck />
                </div>

                <p>{benefit}</p>
              </div>
            ))}
          </div>
          <div className="why-right-button">
            <button className="ccsnl-btn" onClick={() => setShow(true)}>
              Request a Consultation
            </button>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default AIGovernanceLifecycle;
